import { Button, CircularProgress, Grid, Stack, Typography } from '@mui/joy';
import { createFileRoute, Navigate } from '@tanstack/react-router';

import { ContainerLayout } from '@/components/ContainerLayout';
import { UserRegistrationForm } from '@/components/user-registration/UserRegistrationForm';
import { UserWaitingForApproval } from '@/components/user-registration/UserWaitingForApproval';
import { UserGuard } from '@/modules/UserGuard';
import { OrganizationAdminLevelPermission, UserStatus } from '@/modules/api';
import { useUserQuery } from '@/queries/useUserQuery';

export const Route = createFileRoute('/_authenticated/registrierung')({
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  component: RegistrationRoute,
});

export function RegistrationRoute() {
  const { data: user, isLoading } = useUserQuery();

  if (UserGuard.isUser(user) && user.status === UserStatus.ACTIVE) {
    const adminLevelWithPermissionEdit = user.organization?.organization?.adminLevels?.find(
      (adminLevel) => adminLevel.permission === OrganizationAdminLevelPermission.EDIT,
    );

    return (
      <Navigate
        {...(adminLevelWithPermissionEdit
          ? {
              to: '/verkehrszeichen/$adminLevelId',
              params: { adminLevel: adminLevelWithPermissionEdit.adminLevelId },
            }
          : { to: '/verkehrszeichen' })}
        replace
      />
    );
  }

  return (
    <ContainerLayout>
      <Grid container justifyContent="center">
        <Grid md={8}>
          {isLoading && (
            <Stack alignItems="center">
              <CircularProgress />
            </Stack>
          )}

          {!isLoading && !user && (
            <>
              <Typography level="title-lg">Login mit Service-BW</Typography>
              <Typography>
                Um Ihre Registrierung zu starten, müssen Sie sich via Service-BW anmelden. Bitte benutzen Sie Ihre
                amtliche E-Mail.
              </Typography>

              <Button
                component="a"
                href={`/api/authentication/login?relayState=${encodeURIComponent('/registrierung')}`}
                fullWidth
              >
                Login
              </Button>
            </>
          )}

          {UserGuard.isSingleSignOnUser(user) && <UserRegistrationForm singleSignOnUser={user} />}

          {UserGuard.isUser(user) && <UserWaitingForApproval user={user} />}
        </Grid>
      </Grid>
    </ContainerLayout>
  );
}
